module.exports = __webpack_public_path__ + "img/gran-comercio.fcedd909.png";